// extracted by mini-css-extract-plugin
export default {"wrapper":"L3-z","play":"M3-z"};